import { useEffect } from "react";

// Guest checkout is retired: every new order now requires an authenticated
// customer account. Keep this mounted temporarily only to remove the obsolete
// browser key created by older guest-checkout builds; never render a payment
// action that the account-required backend correctly rejects.
const LEGACY_STORAGE_KEY = "arctic_last_guest_order";

export default function AbandonedOrderBanner() {
  useEffect(() => {
    try {
      window.localStorage.removeItem(LEGACY_STORAGE_KEY);
    } catch {
      // Private browsing may deny storage access. There is no UI or network
      // fallback because guest payment recovery is intentionally retired.
    }
  }, []);

  return null;
}
